module.exports = __webpack_public_path__ + "static/media/wallpaperlarge.d1e6486b.jpg";